
<template>
  <div class="super">
    <Headers></Headers>
    <div class="super-center">
      <div class="center-item">
        <img class="item-left" :src="listData.cover" />

        <div class="item-right">
          <p class="right-title">{{ listData.title }}</p>
          <div class="right-text">{{ listData.describe }}</div>
          <div @click="toDownload">
            <img src="../assets/img/phone.png" class="phone" />
            <span class="p"></span>
          </div>
          <div class="right-mon">
            <span class="mon-rmb">￥</span>{{ listData.money }}元
          </div>
        </div>
      </div>
      <div class="center-book">
        <p class="book-title">超级网络课</p>
        <div class="book-body" v-html="listData.content">
          <!-- <img src="https://aliyunosszs.musicwow.com/APPimg/product/product(8).png"> -->
        </div>
      </div>
      <div class="center-add" @click="onPlayData(listData.buy_url)">
        立即购买
      </div>
    </div>

    <div class="footerShow">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Headers from "@/components/header.vue";
import Footer from "@/components/footer.vue";

export default {
  name: "super",
  data() {
    return {
      navData: [],
      listData: [],
      listData: [],
      imgUrl:
        "" || "https://aliyunosszs.musicwow.com/APPimg/product/musicBg.png",
    };
  },
  computed: {},
  components: {
    Headers,
    Footer,
  },
  methods: {
    async onMusicData() {
      let id = this.$route.params.id || localStorage.detailsId;
      this.$ajax
        .get("https://site.musicwow.com/api/v1/product/details/" + id)
        .then((res) => {
          // console.log(res)
          this.listData = res.data.data;
          this.imgUrl = res.data.data.banner[0].image;
          // console.log(this.listData)
        })
        .catch((res) => {
          // console.log(res);
        });
    },
    onPlayData(url) {
      location.href = url;
    },
    toDownload() {
      location.href =
        "https://sj.qq.com/myapp/detail.htm?apkName=com.conwaysmusic.live";
    },
  },
  mounted() {},
  created() {
    this.onMusicData();
  },
};
</script>
<style lang="sass" scoped>
.super
  .super-center
    padding-top: 60px
    text-align: left
    .center-item
      display: flex
      padding: 30px 15px 30px 15px
      border-bottom: 1px solid #ccc
      .item-left
        width: 180px !important
      .item-right
        margin-left: auto
        .right-title
          font-size: 14px
          font-weight: 600
        .right-text
          max-width: 150px
          color: #979797
          font-size: 12px
          line-height: 17px
          padding: 12px 0
        .right-mon
          font-size: 18px
          color: #F56B23
          margin-top: 48px
          .mon-rmb
            font-size: 12px
    .center-book
      margin: 0 15px
      padding-bottom: 50px
      .book-title
        margin: 8px
        font-size: 14px
        font-weight: 600
        color: #333333
      .book-body
        margin: 15px 0
        img
          width: 100%
    .center-add
      position: fixed
      width: 100%
      height: 60px
      background: #07D1AA
      text-align: center
      color: #fff
      line-height: 60px
      font-size: 18px
      left: 0
      right: 0
      bottom: 0
      z-index: 33
.footerShow
  padding-bottom: 60px
</style>

<style lang="scss" scope>
.p {
  font-size: 12px;
  color: #333333;
  vertical-align: middle;
}
.phone {
  width: 10px;
  height: 15px;
  margin-right: 5px;
  vertical-align: middle;
}
iframe {
  width: 100%;
}
</style>